import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import lozad from 'lozad';
import { Clients } from "./components/Clients";
import { Facility } from "./components/Facility";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Home = () => {
  
  useEffect(() => {
    const observer = lozad(); // Initialize lozad
    observer.observe(); // Start observing
  }, []);

  const bannerSettings = {
    dots: true,
    arrows: false,
    lazyLoad: "ondemand",
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    cssEase: "linear",
  };
  const productSettings = {
    dots: true,
    arrows: false,
    lazyLoad: "ondemand",
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 4, // Show 4 products at a time
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1181,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 821,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const instagramSettings = {
    dots: false,
    arrows: false,
    lazyLoad: "ondemand",
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 8,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1181,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 821,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Use state to track the active tab
  const [activeTab, setActiveTab] = useState("all"); // Initialize with the 'all' tab

  // Function to handle tab click
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <section className="BannerSlider">
        <Slider {...bannerSettings}>
          <div className="text-white">
          <div className="vh-100 bg item lozad" style={{ backgroundImage: 'url("images/banner-1.jpg")' }}>
              <div className="container h-100">
                <div className="row align-items-center h-100">
                  <div className="col-lg-5" data-aos="fade-right" data-aos-duration="1000">
                    <span> New Inspiration 2023</span>
                    <h1 className="f-34 fw-700">TRAVEL-SPRING 2023</h1>
                    <p>Up To 30% OFF Select Styles </p>
                    <div className="shop-btn pt-3">
                      <Link to="/ShopWomen" className="btn-w">
                        SHOP WOMEN'S
                      </Link>
                      <Link to="/ShopMen" className="btn-2">
                        SHOP MEN'S
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-white">
          <div className="vh-100 bg item lozad" style={{ backgroundImage: 'url("images/banner-2.jpg")' }}>
              <div className="container h-100">
                <div className="row align-items-center h-100">
                  <div className="col-lg-5" data-aos="fade-right" data-aos-duration="1000">
                    <span> New Inspiration 2023</span>
                    <h1 className="f-34 fw-700">TRAVEL-SPRING 2023</h1>
                    <p>Up To 30% OFF Select Styles </p>
                    <div className="shop-btn pt-3">
                      <a href="#" className="btn-w">
                        SHOP WOMEN'S
                      </a>
                      <a href="#" className="btn-2">
                        SHOP MEN'S
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-white">
          <div className="vh-100 bg item lozad" style={{ backgroundImage: 'url("images/banner-3.jpg")' }}>
              <div className="container h-100">
                <div className="row align-items-center h-100">
                  <div className="col-lg-5" data-aos="fade-right" data-aos-duration="1000">
                    <span> New Inspiration 2023</span>
                    <h1 className="f-34 fw-700">TRAVEL-SPRING 2023</h1>
                    <p>Up To 30% OFF Select Styles </p>
                    <div className="shop-btn pt-3">
                      <a href="#" className="btn-w">
                        SHOP WOMEN'S
                      </a>
                      <a href="#" className="btn-2">
                        SHOP MEN'S
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </section>

      <section className="category">
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-6">
              <div className="category-boxes">
                <div className="cat-img">
                  <img data-src="images/c-1.jpg" className="lozad" alt="category images"/>
                </div>
                <div className="content text">
                  <p>Don’t Miss Today’s Featured Deals</p>
                  <h2 className="fw-700 mb-3">50% OFF</h2>
                  <a href="#" className="btn-1">
                    DISCOVER NOW
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="category-boxes">
                <div className="cat-img">
                  <img data-src="images/c-2.jpg" className="lozad" alt="category images" />
                </div>
                <div className="content text">
                  <p>New Personalizable Collection</p>
                  <h2 className="fw-700 mb-3">50% OFF</h2>
                  <a href="#" className="btn-1">
                    DISCOVER NOW
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="special-offer">
        <div className="container mb-5">
          <div className="row justify-content-center align-items-center text-center text-md-start">
            <div className="col-lg-6 col-md-5" data-aos="fade-down" data-aos-duration="1000">
              <h2 className="f-24 fw-700"> Special Offer </h2>
            </div>

            <div className="col-lg-6 col-md-7">
              {/* <ul class="nav nav-tabs nav-underline justify-content-end" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="all-tab" data-bs-toggle="tab" data-bs-target="#all-tab-pane" type="button" role="tab" aria-controls="all-tab-pane" aria-selected="true">All</button>
              </li>
              <li class="nav-item" role="presentation">
              <button class="nav-link" id="men-tab" data-bs-toggle="tab" data-bs-target="#men-tab-pane" type="button" role="tab" aria-controls="men-tab-pane" aria-selected="false">Men</button>
              </li>
              <li class="nav-item" role="presentation">
              <button class="nav-link" id="women-tab" data-bs-toggle="tab" data-bs-target="#women-tab-pane" type="button" role="tab" aria-controls="women-tab-pane" aria-selected="false">Women</button>
              </li>
            </ul> */}
              <ul
                className="nav nav-tabs nav-underline justify-content-center justify-content-md-end"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "all" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("all")}
                  >
                    All
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "men" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("men")}
                  >
                    Men
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "women" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("women")}
                  >
                    Women
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="tab-content" id="myTabContent">
              <div className={`tab-pane fade ${ activeTab === "all" ? "show active" : ""}`} id="all-tab-pane">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p1.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Linen crochet trim</h6>
                        <span>$191.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p2.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Heartland Alabama</h6>
                        <span>$300.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p3.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Mermaid pencil midi</h6>
                        <span>$250.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p4.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Criss-cross</h6>
                        <span>$191.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p5.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">V neck bodycon</h6>
                        <span>$200.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p6.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">cosmic cornucopia</h6>
                        <span>$500.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p7.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Tenku remastered</h6>
                        <span>$300.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p8.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Lined hoodie</h6>
                        <span>$150.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className={`tab-pane fade ${ activeTab === "men" ? "show active" : ""}`} id="men-tab-pane">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p2.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Heartland Alabama</h6>
                        <span>$300.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p4.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Criss-cross</h6>
                        <span>$191.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className={`tab-pane fade ${ activeTab === "women" ? "show active" : ""}`} id="women-tab-pane">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p1.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Linen crochet trim</h6>
                        <span>$191.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p3.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Mermaid pencil midi</h6>
                        <span>$250.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p5.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">V neck bodycon</h6>
                        <span>$200.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p6.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">cosmic cornucopia</h6>
                        <span>$500.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p7.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Tenku remastered</h6>
                        <span>$300.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p8.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Lined hoodie</h6>
                        <span>$150.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Facility />

      <section className="best-seller">
        <div className="container py-5">
          <div className="row justify-content-center align-items-center text-center text-md-start">
            <div className="col-lg-6 col-md-5" data-aos="fade-down" data-aos-duration="1000">
              <h2 className="f-24 fw-700"> Best Seller Products</h2>
            </div>

            <div className="col-lg-6 col-md-7">
              <ul
                className="nav nav-tabs nav-underline justify-content-center justify-content-md-end"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "all" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("all")}
                  >
                    All
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "men" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("men")}
                  >
                    Men
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "women" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("women")}
                  >
                    Women
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="row mb-4">
            <Slider {...productSettings}>
              <div className="col-lg-3 col-md-6 mt-4 p-2">
                <a href="#" className="product">
                  <div className="product-image">
                      <img src="images/p1.jpg"   alt="product images"/>
                  </div>
                  <div className="product-text mt-2 mb-4">
                    <h6 className="fw-600">Linen crochet trim</h6>
                    <span>$191.00</span>
                    <div className="cart mt-4">
                      <a href="#" className="btn-1 ">
                        ADD TO CART
                      </a>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-md-6 mt-4 p-2">
                <a href="#" className="product">
                  <div className="product-image">
                    <img src="images/p2.jpg"  alt="product images" />
                  </div>
                  <div className="product-text mt-2 mb-4">
                    <h6 className="fw-600">Heartland Alabama</h6>
                    <span>$300.00</span>
                    <div className="cart mt-4">
                      <a href="#" className="btn-1 ">
                        ADD TO CART
                      </a>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-md-6 mt-4 p-2">
                <a href="#" className="product">
                  <div className="product-image">
                    <img src="images/p3.jpg"  alt="product images" />
                  </div>
                  <div className="product-text mt-2 mb-4">
                    <h6 className="fw-600">Mermaid pencil midi</h6>
                    <span>$250.00</span>
                    <div className="cart mt-4">
                      <a href="#" className="btn-1 ">
                        ADD TO CART
                      </a>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-md-6 mt-4 p-2">
                <a href="#" className="product">
                  <div className="product-image">
                    <img src="images/p4.jpg"  alt="product images" />
                  </div>
                  <div className="product-text mt-2 mb-4">
                    <h6 className="fw-600">Criss-cross</h6>
                    <span>$191.00</span>
                    <div className="cart mt-4">
                      <a href="#" className="btn-1 ">
                        ADD TO CART
                      </a>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-md-6 mt-4 p-2">
                <a href="#" className="product">
                  <div className="product-image">
                    <img src="images/p5.jpg"  alt="product images" />
                  </div>
                  <div className="product-text mt-2 mb-4">
                    <h6 className="fw-600">V neck bodycon</h6>
                    <span>$200.00</span>
                    <div className="cart mt-4">
                      <a href="#" className="btn-1 ">
                        ADD TO CART
                      </a>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-md-6 mt-4 p-2">
                <a href="#" className="product">
                  <div className="product-image">
                    <img src="images/p6.jpg"  alt="product images" />
                  </div>
                  <div className="product-text mt-2 mb-4">
                    <h6 className="fw-600">cosmic cornucopia</h6>
                    <span>$500.00</span>
                    <div className="cart mt-4">
                      <a href="#" className="btn-1 ">
                        ADD TO CART
                      </a>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-md-6 mt-4 p-2">
                <a href="#" className="product">
                  <div className="product-image">
                    <img src="images/p7.jpg"  alt="product images" />
                  </div>
                  <div className="product-text mt-2 mb-4">
                    <h6 className="fw-600">Tenku remastered</h6>
                    <span>$300.00</span>
                    <div className="cart mt-4">
                      <a href="#" className="btn-1 ">
                        ADD TO CART
                      </a>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-md-6 mt-4 p-2">
                <a href="#" className="product">
                  <div className="product-image">
                    <img src="images/p8.jpg"  alt="product images" />
                  </div>
                  <div className="product-text mt-2 mb-4">
                    <h6 className="fw-600">Lined hoodie</h6>
                    <span>$150.00</span>
                    <div className="cart mt-4">
                      <a href="#" className="btn-1 ">
                        ADD TO CART
                      </a>
                    </div>
                  </div>
                </a>
              </div>
            </Slider>
          </div>
        </div>
      </section>

      <section className="newsletter">
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-6" data-aos="fade-right" data-aos-duration="1000">
              <h5>SUBSCRIBE TO OUR NEWSLETTER</h5>
              <p className="f-16">
                A short sentence describing what someone will receive by
                subscribing
              </p>
            </div>
            <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1000">
              {/* <input type='email' placeholder='Enter your email address' />
                    <button type='submit' className='btn-1'>SUBSCRIBE</button> */}
              <div className="row align-items-center">
                <div className="col-lg-8 col-7 pe-0 ps-lg-0 pe-lg-0">
                  <input type="email" placeholder="Enter your email address" />
                </div>

                <div className="col-lg-4 col-5 ps-0 ps-lg-0">
                  <button type="submit" className="btn-1 w-100">
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Clients />

      <section className="instagram">
        <div className="container-fluid py-5 p-0">
          <div className="row justify-content-center align-items-center">
            <Slider {...instagramSettings}>
              <div className="col">
                <div className="instagram">
                  <a href="https://www.instagram.com/" target="_blank">
                    <img src="images/instagram1.jpg"  alt="insta images" />
                  </a>
                </div>
              </div>
              <div className="col">
                <div className="instagram">
                  <a href="https://www.instagram.com/" target="_blank">
                    <img src="images/instagram2.jpg"  alt="insta images" />
                  </a>
                </div>
              </div>
              <div className="col">
                <div className="instagram">
                  <a href="https://www.instagram.com/" target="_blank">
                    <img src="images/instagram3.jpg"  alt="insta images" />
                  </a>
                </div>
              </div>
              <div className="col">
                <div className="instagram">
                  <a href="https://www.instagram.com/" target="_blank">
                    <img src="images/instagram4.jpg"  alt="insta images" />
                  </a>
                </div>
              </div>
              <div className="col">
                <div className="instagram">
                  <a href="https://www.instagram.com/" target="_blank">
                    <img src="images/instagram5.jpg"  alt="insta images" />
                  </a>
                </div>
              </div>
              <div className="col">
                <div className="instagram">
                  <a href="https://www.instagram.com/" target="_blank">
                    <img src="images/instagram6.jpg"  alt="insta images" />
                  </a>
                </div>
              </div>
              <div className="col">
                <div className="instagram">
                  <a href="https://www.instagram.com/" target="_blank">
                    <img src="images/instagram7.jpg"  alt="insta images" />
                  </a>
                </div>
              </div>
              <div className="col">
                <div className="instagram">
                  <a href="https://www.instagram.com/" target="_blank">
                    <img src="images/instagram8.jpg"  alt="insta images" />
                  </a>
                </div>
              </div>
              <div className="col">
                <div className="instagram">
                  <a href="https://www.instagram.com/" target="_blank">
                    <img src="images/instagram9.jpg"  alt="insta images" />
                  </a>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
};